import type { Primitive } from "@metaapp/types";
import type { PandoraSDKInterface } from "metaapp-pandora-sdk";
import { babel } from "../submodule/utils/jsb/index";

const {
  env,
  pandoraIndexType,
  pandoraAppkey,
  pandoraBaseUrl,
  pandoraSelfpackagename,
  pandoraZone
} = useConfig();

let Pandora: PandoraSDKInterface | undefined;
const cache: Array<[kind: string, sendparams: Record<string, Primitive>, desc: string]> = [];

isClient() &&
  import("metaapp-pandora-sdk").then((res) => {
    Pandora = res.default;

    Pandora.send(
      "config",
      {
        index_type: pandoraIndexType,
        selfpackagename: pandoraSelfpackagename,
        env: env.toLowerCase(),
        debug: false
      },
      {
        isMontageAppkey: true,
        appkey: pandoraAppkey,
        zone: pandoraZone,
        baseUrl: pandoraBaseUrl
      }
    );

    Pandora.send("start");

    while (cache.length > 0) {
      const arr = cache.shift();
      const k = arr?.[0];
      const send = arr?.[1];
      const desc = arr?.[2];
      if (k && send && desc) {
        Pandora.send(k, desc, send   );
      }
    }
  });

export const pandora = {
  send: (kind: string, desc: string, sendparams: Record<string, Primitive>) => {
    if (isClient()) {
      if (!Pandora) {
        cache.push([kind, sendparams, desc]);
        return;
      }
      if (babel?.clientVersion && babel.clientVersion >= 7 && babel.clientType === "android") {
        babel.execAsync("clientTrackPoint", {
          kind,
          data: JSON.stringify(sendparams)
        });
      } else if (
        jsb &&
        ((window as any).MetaX || (window as any)?.webkit?.messageHandlers?.MetaX)
      ) {
        jsb.execAsyncV2("nativeAnalytics", kind, desc, JSON.stringify(sendparams));
      } else {
        setTimeout(() => {
          Pandora.send(kind, desc, sendparams);
        }, 10000);
      }

      // TODO 如果在客户端环境需要处理一下采用客户端发版
      // Pandora.send(kind, desc, sendparams);
    }
  }
};
